import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/utils";


interface ConditionalRouteProps{
  component: React.ComponentType;
  isPrivate?: boolean
}
const ConditionalRoute: React.FC<ConditionalRouteProps> =( {

  component: Component,
  isPrivate = false,
})=>{
  const isAuthenticated = !!getToken();

  if (isPrivate && !isAuthenticated) {
    return <Navigate to="/login" />;
  } else if (!isPrivate && isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  return <Component />;
};

export default ConditionalRoute;
